// extracted by mini-css-extract-plugin
module.exports = {"content":"GameLog_content__zJzmk"};